import { maestroApiCall } from '@michelin/central-provider';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import { baseURL } from 'Types/APITypes';

async function getRotations(stNumber: string, date: string) {
  if (!stNumber || !date) return null;
  return maestroApiCall({ method: 'GET', endpoint: `tech-rotation/${stNumber}?date=${date}`, baseURL });
}

const FIFTEEN_MINUTES = 15 * 60 * 1000;

export function useGetRotations(stNumber: string, date: string) {
  return useQuery(['rotations', stNumber, date], () => getRotations(stNumber, date), {
    staleTime: FIFTEEN_MINUTES,
  });
}

async function getRotationList(stNumber: string) {
  if (!stNumber) return null;
  return maestroApiCall({ method: 'GET', endpoint: `tech-rotation/${stNumber}/list`, baseURL });
}

export function useGetRotationList(stNumber: string) {
  return useQuery(['rotation-list', stNumber], () => getRotationList(stNumber), {
    staleTime: FIFTEEN_MINUTES,
  });
}

export function useSaveRotations(stNumber: string, onError?: (error: unknown) => void) {
  const queryClient = useQueryClient();
  return useMutation(
    (rotations: object[]) => maestroApiCall(
      { method: 'POST', endpoint: `tech-rotation/${stNumber}`, baseURL },
      rotations,
    ),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['rotations', stNumber]);
      },
      onError,
    },
  );
}

export function useSaveRotationList(stNumber: string, onError?: (error: unknown) => void) {
  const queryClient = useQueryClient();
  return useMutation(
    (rotationList: object | null) => maestroApiCall(
      { method: 'POST', endpoint: `tech-rotation/${stNumber}/list`, baseURL },
      rotationList ?? undefined,
    ),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['rotation-list', stNumber]);
        queryClient.invalidateQueries(['rotations', stNumber]);
      },
      onError,
    },
  );
}
